





define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        var searchKeyName = ApiKeyNames.search;

        return function() {
            return {
                search: requestFactory.single(endpoints.search, searchKeyName),
                batch: requestFactory.batch(100, {
                    single: endpoints.batchSearchQuery,
                    batchSync: endpoints.batchSyncSearch,
                    batch: endpoints.batchSearch
                }, searchKeyName)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/search.js